<template>
  <div ref="playerDiv" class="player" :style="{height: `${playerHeight}px`}">
    <div class="player-wrapper">
      <video
        ref="video"
        :controls="controls"
        class="video-js video-js-player vjs-theme-fantasy"
        :data-setup="settings"
      >
      </video>
    </div>
  </div>
</template>

<script>

import throttle from 'lodash/throttle';
import 'video.js/dist/video-js.css';
import '@videojs/themes/dist/fantasy/index.css';
import videojs from 'video.js';

export default {

  props: {
    videoId: {
      type: String,
      require: true,
    },

    points: {
      type: Array,
      default: () => [],
    },

    controls: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      player: null,
      playerWidth: 800,
      innerPoints: [],
    };
  },

  computed: {
    settings () {
      return JSON.stringify({
        height: '500',
        autoplay: false,
        muted: false,
        language: 'es',
        languages: {
          es: {
            Play: 'Reproducción',
            Pause: 'Pausa',
            'Current Time': 'Tiempo reproducido',
            Duration: 'Duración total',
            'Remaining Time': 'Tiempo restante',
          },
        },
        controls: true,
        controlBar: {
          liveDisplay: true,
          pictureInPictureToggle: false,
        },
        // playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: 'video/mp4',
          src: this.videoUrl,
        }],
        poster: this.posterUrl,
      });
    },

    videoUrl () {
      return `${process.env.VUE_APP_BASE_API_URL}/api/video/${this.videoId}`;
    },

    posterUrl () {
      return `${this.videoUrl}/poster`;
    },

    playerHeight () {
      return Math.floor(this.playerWidth * 56.25 / 100);
    },
  },

  watch: {
    videoId () {
      this.player.src({ type: 'video/mp4', src: this.videoUrl });
      this.player.poster(this.posterUrl);
      this.innerPoints.forEach(point => (point.done = false));
    },
  },

  methods: {
    resizeHandler: throttle(function () {
      this.playerWidth = this.$refs.playerDiv.clientWidth;
    }, 500),

    processHandler: throttle(function () {
      this.innerPoints.forEach(point => {
        const time = point.time === Infinity ? Math.floor(this.player.duration()) : point.time;

        if (this.player.currentTime() >= time && !point.done) {
          point.done = true;
          point.cb();
        }
      });
    }, 2000),

    init () {
      this.innerPoints = this.points.map(point => ({ ...point }));
      this.playerWidth = this.$refs.playerDiv.clientWidth;
      window.addEventListener('resize', this.resizeHandler);
      const _this = this;
      videojs(this.$refs.video).ready(function () {
        _this.player = this;
        _this.player.on('timeupdate', _this.processHandler);
        _this.player.on('ended', () => _this.$emit('ended'));
      });
    },
  },

  mounted () {
    this.init();
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.resizeHandler);
  },
};
</script>

<style lang="scss" scoped>
.video-js-player  {
  &::v-deep {
    .vjs-control-bar {
      // bottom: 61px;
      z-index: 3;
    }

    .vjs-text-track-display {
      pointer-events: all;
    }

    .vjs-control {
      color: #fa507b
    }

    .vjs-play-progress {
      background-color: #fa507b;
    }

    &.vjs-paused  {
      .vjs-big-play-button {
        display: block;
      }
    }

    .vjs-big-play-button {
      background: #fa507b;
      color: white;
      border-radius: 3px;
      width: 100px;
      margin-left: -50px;
    }

    &.vjs-fullscreen {
      .vjs-control-bar {
        bottom: 0;
        z-index: 3;
      }
    }

    .vjs-slider:focus {
      text-shadow: unset;
      box-shadow: unset;
    }

    .vjs-load-progress,
    .vjs-load-progress div {
      background: transparent;
    }
  }
}

 .video-js-player {
  width: 100%;
  height: 100%;
  // position: absolute;
  // top: -61px;
  // left: 0;
}

.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-active {
  transition: opacity 0s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.player {
  max-width: 900px;
  width: 100%;
  height: 100%;
  // position: relative;
  // overflow: hidden;
  // background: #000;
  // margin: auto;

  .player-wrapper {
    // max-width: 100%;
    // height: 0;
    // position: relative;
    // overflow: hidden;
    // padding-bottom: calc(56.25% + 122px);
    height: 100%;
  }
}

.control {
  width: 100%;
  background: rgb(0 0 0 / 40%);
  position: absolute;
  bottom: 120px;
  z-index: 3;
  color: white;
}

.control-icon {
  // width: 44px;
  // height: 48px;
  cursor: pointer;
}
</style>
